export default __webpack_public_path__ + "static/media/LegendaMissionControlIngles.346bf3d6.svg";